import { connect, MapStateToProps } from 'react-redux';
import React from 'react';
import { IUserInfos } from 'store/makhsanUserInfo/makhsanUserInfoSlice';
import { RootState } from 'store/store';
import { myLoginActivity } from 'api/MakhsanApi';
import {
  IUserSecurityEvent,
  SecurityEventLevel,
} from 'store/entity/IUserSecurityEvent';
import { smartDateString } from 'utils/date';
import notify from '../../../components/Notify';
import LoadingCircleIndicator from '../../../components/LoadingCircleIndicator/LoadingCircleIndicator';
import { LogItem, LogItems } from './styles';
import { IThisUserState } from 'store/thisUser/thisUserSlice';
import i18n from '../../../i18n';

interface IStateToProps {
  thisUser: IThisUserState;
  userInfos: IUserInfos;
  store: RootState;
}

interface IOwnProps {}

interface IComponentState {
  type?: string;
  level?: SecurityEventLevel;
  ip?: string;
  logs: IUserSecurityEvent[];
  loading?: boolean;
}
type IComponentProps = IStateToProps & IOwnProps;

class MyLogViewPanel extends React.PureComponent<
  IComponentProps,
  IComponentState
> {
  state: IComponentState = {
    loading: false,
    logs: [],
  };
  handleSearch = () => {
    this.setState({ loading: true });
    myLoginActivity(this.props.store).then(
      (result) => {
        this.setState({ loading: false, logs: result.data });
      },
      (e) => {
        this.setState({ loading: false });
        notify(e.data.message);
      }
    );
  };

  componentDidMount(): void {
    this.handleSearch();
  }

  render() {
    const { loading, logs } = this.state;
    // const { userInfos, user } = this.props;
    return (
      <div>
        <div style={{ display: 'flex' }}>
          {loading ? (
            <LoadingCircleIndicator />
          ) : (
            <LogItems>
              {logs.map((log: IUserSecurityEvent) => {
                return (
                  <LogItem
                    level={log.level}
                    className="row"
                    key={log.id.toString()}
                  >
                    <div className="col s12 m6">
                      {i18n.t(`${log.type}`, { ns: 'profile' }) as string}
                    </div>
                    <div className="col s12 m6">
                      {(i18n.t('date', { ns: 'profile' }) as string) +
                        ': ' +
                        smartDateString(new Date(log.date), true)}
                    </div>
                  </LogItem>
                );
              })}
            </LogItems>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps: MapStateToProps<IStateToProps, IOwnProps, RootState> = (
  state
) => {
  const userInfos = state.makhsanUserInfo;
  const thisUser = state.thisUser;
  return { userInfos: userInfos, thisUser, store: state };
};

export default connect<IStateToProps, unknown, IOwnProps, any>(
  mapStateToProps,
  null
)(MyLogViewPanel);
